import React, {useEffect, forwardRef} from 'react';
import PropTypes from 'prop-types';
import Select, {createFilter} from 'react-select';
import CreatableSelect from 'react-select/creatable';
//MUI
import {emphasize, useTheme, makeStyles} from '@material-ui/core/styles';
import NoSsr from '@material-ui/core/NoSsr';
//Componentes
import * as toast from '../../../common/toast';
import NoOptionsMessage from './components/NoOptionsMessage';
import Control from './components/Control';
import Option from './components/Option';
import Placeholder from './components/Pleaceholder';
import SingleValue from './components/SingleValue';
import ValueContainer from './components/ValueContainer';
import MultiValue from './components/MultiValue';
import Menu from './components/Menu';
import MenuList from './components/MenuList';
import OptionExceso from './components/OptionExceso';
import {SB_NUEVO, SB_REGEX_META} from '../../../constants/componentValues';
import {cadenas} from 'lib.common';
const useStyles = makeStyles((theme) => ({
   input: {
      display: 'flex',
      paddingTop: 0,
      paddingLeft: 8,
      paddingBottom: 1,
      paddingRight: 0,
      height: 'auto'
   },
   valueContainer: {
      display: (props) => (props.isMulti ? 'flex' : 'inline-flex'),
      flexWrap: (props) => (props.isMulti ? 'wrap' : undefined),
      flex: 1,
      alignItems: 'center',
      overflow: 'hidden'
   },
   chip: {
      margin: theme.spacing(0.5, 0.25)
   },
   chipFocused: {
      backgroundColor: emphasize(
         theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
         0.08
      )
   },
   noOptionsMessage: {
      padding: theme.spacing(1, 2)
   },
   singleValue: {
      fontSize: theme.fontSize
   },
   placeholder: {
      position: 'absolute',
      left: 8,
      fontSize: theme.fontSize
   },
   paper: {
      position: 'absolute',
      zIndex: '999 !important',
      marginTop: theme.spacing(-1),
      left: 0,
      right: 0
   }
}));

const componentsExceso = {
   Menu,
   MenuList,
   Control,
   MultiValue,
   NoOptionsMessage,
   Placeholder,
   SingleValue,
   ValueContainer,
   Option: OptionExceso
};

const componentsSimple = {
   Control,
   Menu,
   MultiValue,
   NoOptionsMessage,
   Option,
   Placeholder,
   SingleValue,
   ValueContainer
};
/**
 * Combobox con autocompletado y opciones de seleccion individual y multiple.<br/>
 * Para mayor personalizacion visital el componente original [reac-select](https://react-select.com/props#api), algunas propiedades son extensiones del componente TextField de [Material-UI](https://material-ui.com/api/text-field/).
 */
const SelectBase = React.forwardRef(function SelectBase(props, ref) {
   const classes = useStyles(props);
   const theme = useTheme();

   const selectStyles = {
      option: (provided, state) => ({
         ...provided,
         whiteSpace: 'nowrap'
      }),
      input: (base) => ({
         ...base,
         color: theme.palette.text.primary,
         '& input': {
            font: 'inherit'
         }
      })
   };

   const {
      label,
      error,
      helperText,
      variant,
      margin,
      className,
      name,
      excesoElementos,
      permitirNuevosValores,
      disabled,
      onChange,
      logCambios,
      menuWidth,
      onInputChange,
      sinMargen,
      mensajeNuevoValor,
      asignarPrimerOption,
      esId,
      onCleanNewValue,
      ...other
   } = props;

   const margin0 = sinMargen ? {style: {margin: '0px'}} : {};

   const textFieldProps = {
      error,
      label,
      InputLabelProps: {
         htmlFor: 'react-select',
         shrink: true
      },
      helperText,
      variant,
      margin,
      className,
      name,
      ...margin0
   };

   useEffect(() => {
      let valorAsignado = props.value;
      if (
         valorAsignado &&
         valorAsignado.value &&
         !valorAsignado.value.match(SB_REGEX_META) &&
         !valorAsignado.label &&
         props.options &&
         props.options.length > 0
      ) {
         valorAsignado = props.options.find((item) => {
            return item.value === valorAsignado.value;
         });
         if (!valorAsignado) {
            valorAsignado = props.value;
         }
         onChange(valorAsignado);
      }
   }, [props.value, props.options]);

   useEffect(() => {
      if (
         (!props.value || !props.value.value) &&
         props.options &&
         props.options.length > 0 &&
         props.options[0].value &&
         !props.options[0].value.match(SB_REGEX_META) &&
         asignarPrimerOption
      ) {
         onChange({value: props.options[0].value, label: props.options[0].label});
      }
   }, [props.options]);

   function handleChange(newValue, actionMeta) {
      if (logCambios) {
         console.group('Value Changed');
         console.log(newValue);
         console.log(`action: ${actionMeta.action}`);
         console.groupEnd();
      }
      if (newValue && newValue.value) {
         if (newValue.value.match(SB_REGEX_META)) {
            return;
         }

         if (esId) {
            newValue.value = cadenas.removeSpaces(newValue.value);
            toast.showWarning(
               'Se eliminaron todos los espacios en blanco del id/codigo seleccionado'
            );
         } else {
            newValue.value = newValue.value.trim();
         }

         if (newValue[SB_NUEVO]) {
            if (onCleanNewValue) {
               console.log('🚀 ~ handleChange ~ onCleanNewValue:', onCleanNewValue);
            }
            newValue.label = newValue.value;
         }
         const valorExistente = props.options.find((item) => {
            return item.value === newValue.value;
         });
         if (valorExistente) {
            newValue = valorExistente;
            delete newValue[SB_NUEVO];
         }
         if (newValue.label) {
            newValue.label = newValue.label.trim();
         }
      }
      onChange(newValue);
   }
   function handleInputChange(inputValue, actionMeta) {
      if (logCambios) {
         console.group('Input Changed');
         console.log(inputValue);
         console.log(`action: ${actionMeta.action}`);
         console.groupEnd();
      }
      if (typeof onInputChange === 'function') {
         return onInputChange(inputValue);
      } else {
         return inputValue;
      }
   }
   const components =
      excesoElementos || (props.options && props.options.length > 100)
         ? componentsExceso
         : componentsSimple;
   if (permitirNuevosValores) {
      return (
         <NoSsr>
            <CreatableSelect
               ref={ref}
               classes={classes}
               styles={selectStyles}
               inputId="react-select"
               TextFieldProps={textFieldProps}
               components={components}
               filterOption={createFilter({ignoreAccents: false})}
               isDisabled={disabled}
               {...other}
               isClearable
               onChange={handleChange}
               onInputChange={handleInputChange}
               formatCreateLabel={(userInput) => `${mensajeNuevoValor} ${userInput}`}
               //menuPortalTarget={document.body}
               menuWidth={menuWidth}
            />
         </NoSsr>
      );
   } else {
      return (
         <NoSsr>
            <Select
               ref={ref}
               classes={classes}
               styles={selectStyles}
               inputId="react-select"
               TextFieldProps={textFieldProps}
               components={components}
               filterOption={createFilter({ignoreAccents: false})}
               isDisabled={disabled}
               onChange={handleChange}
               onInputChange={handleInputChange}
               //menuPortalTarget={document.body}
               menuWidth={menuWidth}
               {...other}
            />
         </NoSsr>
      );
   }
});

SelectBase.propTypes = {
   /**
    * Si es `true` el componente permite seleccion multiple de opciones.
    */
   isMulti: PropTypes.bool,
   /**
    * Atributo nombre del elemento input.
    */
   name: PropTypes.string,
   /**
    * Texto a mostrar como nombre del componente.
    */
   label: PropTypes.string,
   /**
    * Texto de ayuda sobre el contenido.
    */
   helperText: PropTypes.string,
   /**
    * Si es `true`, el componente se mostrara en estado de error.
    */
   error: PropTypes.bool,
   /**
    * Variante a usar.
    */
   variant: PropTypes.oneOf(['standard', 'outlined', 'filled']),
   /**
    * Si tiene valor `dense` o `normal`
    */
   margin: PropTypes.oneOf(['none', 'dense', 'normal']),
   /**
    * Personalizacion CSS del componente.
    */
   className: PropTypes.string,
   /**
    * Contenido del desplegable. value representa el valor del estado de la opcion y label es el texto a mostrar.
    */
   options: PropTypes.arrayOf(
      PropTypes.shape({
         value: PropTypes.string,
         label: PropTypes.string
      })
   ),
   /**
    * Numero para cambiar el ancho del menu
    */
   menuWidth: PropTypes.number,
   /**
    * Booleano para indicar que se mostraran los titulos al pasar el mouse
    */
   titulos: PropTypes.bool,
   /**
    * Booleano para indicar si la informacion se mostrara en una sola linea
    */
   unaLinea: PropTypes.bool,
   /**
    * Si __true__ convertira los valores ingresados a mayusculas
    */
   inputMayuscula: PropTypes.bool,
   /**
    * Si __true__ pone todos los margenes a 0px
    */
   sinMargen: PropTypes.bool,
   /**
    * Cadena a mostrar al crear un nuevo elemento
    */
   mensajeNuevoValor: PropTypes.string,
   /**
    * Si `permitirNuevosValores` y `esId` son __true__ se eliminaran todos los espacios en blanco del nuevo valor
    */
   esId: PropTypes.bool,
   /** Funcion para limpiar `value.value` cuando `permitirNuevosValores` es __true__:
    *
    * - `nuevoValor`: Nuevo `value.value`, si `permitirNuevosValores` y `esId` son __true__ este valor no tendra ningun espacio en blanco.
    * - `retorno`: `string`, nuevo valor a asignado a `value.value` del nuevo elemento.
    */
   onCleanNewValue: PropTypes.func
};

SelectBase.defaultProps = {
   mensajeNuevoValor: 'Crear:',
   isMulti: false,
   margin: 'normal',
   error: false,
   variant: 'standard',
   menuWidth: 0,
   inputMayuscula: false,
   sinMargen: false
};

export default SelectBase;
